import React from "react";
import {
  FaTachometerAlt,
  FaUserFriends,
  FaUsers,
  FaCar,
  FaCheck,
  FaBars,
  FaReadme,
  FaChartBar,
  FaFile,
  FaBriefcase,
  FaCity,
} from "react-icons/fa";
import { AppSubjects } from "../../../casl/ability";

export interface SidebarLink {
  id: number;
  menuName: string;
  menuIcon: React.ReactNode;
  path: string;
  subject: AppSubjects;
  children?: SidebarLink[];
}

export const SidebarLinks: SidebarLink[] = [
  {
    id: 1,
    menuName: "Dashboard",
    menuIcon: <FaTachometerAlt size={15} />,
    path: "/",
    subject: "Dashboard",
  },
  {
    id: 2,
    menuName: "Party Master",
    menuIcon: <FaUserFriends size={17} />,
    path: "/parties",
    subject: "PartyMaster",
  },
  {
    id: 3,
    menuName: "City Master",
    menuIcon: <FaCity size={17} />,
    path: "/cities",
    subject: "CityMaster",
  },
  {
    id: 4,
    menuName: "Employee Master",
    menuIcon: <FaUsers size={17} />,
    path: "/employees",
    subject: "EmployeeMaster",
  },
  {
    id: 5,
    menuName: "Transporter Master",
    menuIcon: <FaCar size={17} />,
    path: "/transporters",
    subject: "TransporterMaster",
  },
  {
    id: 6,
    menuName: "Pick List",
    menuIcon: <FaBriefcase size={17} />,
    path: "/pick-lists",
    subject: "PickList",
  },
  {
    id: 7,
    menuName: "Checker Panel",
    menuIcon: <FaCheck size={17} />,
    path: "/checker-panel",
    subject: "CheckerPanel",
  },
  {
    id: 8,
    menuName: "Pending Invoice",
    menuIcon: <FaBars size={17} />,
    path: "/pending-invoices",
    subject: "PendingInvoice",
  },
  {
    id: 9,
    menuName: "Pre Dispatch Report",
    menuIcon: <FaFile size={17} />,
    path: "/pre-dispatch-report",
    subject: "PreDispatchReport",
  },
  {
    id: 10,
    menuName: "Dispatch Report",
    menuIcon: <FaReadme size={17} />,
    path: "/dispatch-report",
    subject: "DispatchReport",
  },
  {
    id: 11,
    menuName: "Dispatch Summary",
    menuIcon: <FaChartBar size={17} />,
    path: "/dispatch-summary",
    subject: "DispatchSummary",
  },
];
